import { useRouteMatches } from '@luminovo/design-system';

import type { RouteChrome } from './staticData';

/** `projectId` comes from the match that declared `'project'`, so the navbar never shows a project the URL doesn't. */
export type ResolvedChrome = { navbar: 'home' } | { navbar: 'project'; projectId: string } | { navbar: 'none' };

/** The leaf match's chrome; home when it declares none, as the test harness's routes (`router-testing`) don't. */
export function useRouteChrome(): ResolvedChrome {
    // The only thing that decides chrome: nothing matches pathname prefixes to pick a navbar.
    const leaf = useRouteMatches().at(-1);
    return toResolvedChrome(leaf?.staticData.chrome ?? 'home', leaf?.params.projectId);
}

function toResolvedChrome(chrome: RouteChrome, projectId: string | undefined): ResolvedChrome {
    if (chrome !== 'project') {
        return { navbar: chrome };
    }
    // `routeTree.test.ts` asserts every `'project'` route has a `projectId`; this guards a slip anyway.
    return projectId === undefined ? { navbar: 'home' } : { navbar: 'project', projectId };
}
